
import React, { useEffect } from 'react';
import { Clock, MapPin, UserCheck } from 'lucide-react';
import { formatDistanceToNow } from 'date-fns';
import { PollMetadataProps } from './types';
import { useVoteFiltering } from '@/hooks/polls/useVoteFiltering';
import { reconcilePollVotes } from '@/utils/polls/pollReconciliation';

const PollMetadata: React.FC<PollMetadataProps> = ({ poll, showLocation = true, variant = 'default' }) => {
  if (variant === 'compact') return null;
  
  // Use the useVoteFiltering hook to get accurate vote counts
  const { voteStats } = useVoteFiltering(poll);
  
  // Ensure poll data is reconciled when component mounts
  useEffect(() => {
    if (poll?.id) {
      // Only run this once per component mount to avoid excessive calls
      reconcilePollVotes(poll.id).catch(error => {
        console.error("Error reconciling poll votes:", error);
      });
    }
  }, [poll?.id]);
    
  const formattedDate = poll.created_at
    ? formatDistanceToNow(new Date(poll.created_at), { addSuffix: true })
    : '';
    
  return (
    <div className="mt-4 flex flex-wrap gap-3 text-xs text-muted-foreground">
      {poll.created_at && (
        <div className="flex items-center gap-1">
          <Clock size={14} />
          <span>{formattedDate}</span>
        </div>
      )}
      
      {showLocation && poll.country_code && (
        <div className="flex items-center gap-1">
          <MapPin size={14} />
          <span>{poll.country_code === 'GL' ? 'Global' : poll.country_code}</span>
        </div>
      )}
      
      <div className="flex items-center gap-1">
        <UserCheck size={14} />
        <span>{voteStats.totalVotes || 0} votes</span>
      </div>
    </div>
  );
};

export default PollMetadata;
